import Vue from 'vue'
import Vuex from 'vuex'

import { vuexfireMutations, firestoreAction } from 'vuexfire'

import firebaseInstance from "./firebase/config/firebaseExports"
import "firebase/firestore";

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    storePeople: [],
    storeStories: []
  },
  mutations: {
    ...vuexfireMutations,
  },
  actions: {
    setPeople: firestoreAction(({ bindFirestoreRef }, ref) => {
      bindFirestoreRef('storePeople', ref)
    }),
    setStories: firestoreAction(({ bindFirestoreRef }, ref) => {
      bindFirestoreRef('storeStories', ref)
    })
  }
})


store.dispatch(
  "setPeople",
  firebaseInstance.firestore().collection("people")
);

store.dispatch(
  "setStories",
  firebaseInstance.firestore().collection("stories")
);

export default store;
